import v8n from 'v8n'
import validatorUtils from './validation_utils'

export default {
  create (data) {
    const schema = {
      // solved: v8n().not.null().boolean(),

      // @todo: uncomment here to require second question
      // knowhow: v8n().not.null().boolean(),

      ratingAttendant: v8n().not.null()
        .greaterThanOrEqual(1)
        .lessThanOrEqual(5),

      // ratingCompany: v8n().not.null()
      //   .greaterThanOrEqual(1)
      //   .lessThanOrEqual(5),

      // comment: v8n().not.null().minLength(3),
    }
    return v8n()
      .schema(schema)
      .testAsync(data)
      .then(() => ({ success: true }))
      .catch(e => validatorUtils.buildErrors('survey', e))
  }
}
